import { Input, OnChanges } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import * as Highcharts from "highcharts";

import { CHARTS } from "../../../../../models/charts";
import { DrilldownDialogComponent } from "@dialogs/drilldown/drilldown.component";

@Component({
    selector: "app-high-chart",
    templateUrl: "./high-chart.component.html",
    styleUrls: ["./high-chart.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class HighChartComponent implements OnInit, OnChanges {
  @Input() data: any = [];
  @Input() type?: string;
  @Input() preview?: boolean;
  @Input() hasEdit?: boolean = true;
  @Input() dataPoints?: any = [];
  @Input() canvasType?: any;
  @Input() form?: any;
  @Input() chartData: any = [];

  constructor(
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    public parentF: FormGroupDirective
  ) {
    this.chartForm = this.fb.group({
      title: new UntypedFormControl(""),
    });
  }

  public pageLinking: boolean = false;
  public title: string = "";
  public description: string = "";

  faCircleInfo = faCircleInfo;

  openDetailWindow(index: number, userOptions: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {};
    dialogConfig.width = "75vw";

    dialogConfig.panelClass = "dialog-with-close";
    dialogConfig.disableClose = false;

    setTimeout(() => {
      dialogConfig.data = {
        form: this.childForm || this.form,
        title: "Detailed Data Information",
        userOptions: userOptions,
        index: index,
      };
      this.dialog.open(DrilldownDialogComponent, dialogConfig);
    }, 100);
  }

  public chartIcon: any;
  public showChart: boolean = false;
  public update: boolean = true;
  public oneToOne: boolean = true;
  Highcharts: typeof Highcharts = Highcharts;

  chartOptions!: any;
  childForm: any;

  chartForm: UntypedFormGroup;

  ngOnChanges() {
    this.update = true;
    let that = this;
    if (this.childForm)
      this.pageLinking =
        this.childForm.get("drilldownEnabled").value && !this.preview;
    const chart = CHARTS.filter((item: any) => {
      return item.type.details == this.type;
    });
    if (chart[0]) {
      this.chartIcon = chart[0].icon;
    }

    if (this.data.series && this.data.series.length > 0) {
      this.showChart = true;
      if (this.data.plotOptions.series.point) {
        this.data.plotOptions.series.point.events.click = function () {
          that.openDetailWindow(this.index, this.series.userOptions);
        };
      }
      if (this.childForm) {
        const reportTitle = this.childForm.get("title").value;
        if (!this.data.title.text) {
          this.data.title.text = reportTitle;
        }
      }
      const reflow = {
        render: function (this: Highcharts.Chart) {
          if (this && typeof this.reflow === "function") {
            this.reflow();
          }
        },
        load: function (this: Highcharts.Chart) {
          const c = this;
          setTimeout(() => {
            if (c && typeof c.reflow === "function") {
              c.reflow();
            }
          }, 100);
        },
      };

      if (this.data.series[0].zones) {
        if (this.data.legend) {
          this.data.legend.symbolHeight = 1;
          this.data.legend.symbolWidth = 1;
        }
      }

      this.data.chart.events = reflow;
      this.data.chart.reflow = true;
      this.chartOptions = this.data;
    } else {
      this.showChart = false;
    }

    if (this.data) {
      if (this.data.title) {
        this.data.title.text = null;
      }

      if (this.data.subtitle) {
        this.data.subtitle.text = null;
      }

      if (
        this.data.chart &&
        this.data.chart.type == "pie" &&
        this.data.plotOptions
      ) {
        let dataLabels = {};
        let style = {
          fontWeight: "normal",
        };

        this.data.plotOptions.series.dataLabels = dataLabels;
        this.data.plotOptions.series.dataLabels.style = style;
      }
    }

    if (this.childForm) this.title = this.childForm.get("title").value;

    if (
      this.chartData &&
      this.childForm &&
      this.chartData.modifications.data.formatters.data &&
      this.chartData.modifications.data.formatters.data.length > 0
    ) {
      this.title =
        this.chartData.modifications.data.formatters.data[0].value ||
        this.childForm.get("title").value;
      if (this.chartData.modifications.data.formatters.data[1]) {
        this.description =
          this.chartData.modifications.data.formatters.data[1].value;
      }
    }
  }

  ngOnInit() {
    this.childForm = this.parentF.form;
    if (this.childForm && !this.preview)
      this.pageLinking = this.childForm.get("drilldownEnabled").value;
    this.ngOnChanges();
  }
}
